const styles = {
  container: {
    position: 'absolute',
    top: '5vh',
    paddingLeft: '3em',
  },
};

export default styles;
